import { useAppSelector, useAppDispatch } from "@/services/hooks";
import React, { useEffect } from "react";

import PersonalInformationContainer from "./PersonalInformationContainer";
import { Card, CardHeader, CardBody, Container } from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import {
  clearCloudinaryPath,
  setCloudinaryPath,
} from "@/services/ImageServices/ImageActions";

const AddUserContainer = () => {
  const dispatch = useAppDispatch();

  // (Only if we need something from the store; otherwise we can remove this)
  const registeredUser = useAppSelector((state) => state.users.register_user);

  useEffect(() => {
   
    dispatch(setCloudinaryPath("USERS"));
    return () => {
      dispatch(clearCloudinaryPath());
    };
  }, [dispatch]);

  return (
    <>
      <SimpleHeader name="Add User" parentName="Users" />
      <Container className="mt--6" fluid>
        <Card>
          <CardHeader className="text-center">
            <h3 className="mb-0">Personal Information</h3>
          </CardHeader>
          <CardBody className="text-center">
            <PersonalInformationContainer/>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default AddUserContainer;
